// Frise 24 h calée sur mon fuseau : mêmes abscisses = même instant pour tout le monde.
// Un créneau de 15 min a quatre états : ensemble (nous deux travaillons), lui seul, hors horaires, nuit.
import { STEP, bounds, info } from './time';
import { status, working, type Hours, type Status } from './contact';

export type SlotKind = Status | 'both';

export interface DayGrid {
  date: string;
  tz: string;
  start: number;
  end: number;
  /** Nombre de créneaux de 15 min : 96 en temps normal, 92 ou 100 les jours de changement d’heure. */
  slots: number;
  hours: number;
}

export function dayGrid(date: string, tz: string): DayGrid {
  const { start, end } = bounds(date, tz);
  return { date, tz, start, end, slots: Math.round((end - start) / STEP), hours: (end - start) / 3_600_000 };
}

/** Bande d’un contact : pour chaque créneau, son état, et « ensemble » quand je travaille aussi. */
export function contactBand(grid: DayGrid, contact: Hours, me: Hours | null): SlotKind[] {
  const out: SlotKind[] = [];
  for (let i = 0; i < grid.slots; i++) {
    const t = grid.start + i * STEP + STEP / 2;
    const s = status(contact, t);
    out.push(s === 'work' && me && working(me, t) ? 'both' : s);
  }
  return out;
}

/** Ma propre bande : au travail, hors horaires, nuit. */
export function meBand(grid: DayGrid, me: Hours): Status[] {
  const out: Status[] = [];
  for (let i = 0; i < grid.slots; i++) out.push(status(me, grid.start + i * STEP + STEP / 2));
  return out;
}

export interface HourLabel {
  /** Position en pourcentage de la largeur. */
  left: number;
  text: string;
}

/** Repères horaires : toutes les 3 h, dans le fuseau de la frise ; le dernier repère est minuit. */
export function hourLabels(grid: DayGrid, every = 3): HourLabel[] {
  const out: HourLabel[] = [];
  for (let h = 0; h < grid.hours - 1; h += every) {
    const p = info(grid.tz, grid.start + h * 3_600_000);
    out.push({ left: (h / grid.hours) * 100, text: `${String(p.h).padStart(2, '0')}h` });
  }
  out.push({ left: 100, text: '00h' });
  return out;
}

/** Position de « maintenant » sur la frise, entre 0 et 1, ou null hors de la journée affichée. */
export function nowFraction(grid: DayGrid, now: number): number | null {
  if (now < grid.start || now >= grid.end) return null;
  return (now - grid.start) / (grid.end - grid.start);
}
